<script>
import baseMixin from '@/mixins/baseMixin'
import timesheetMixin from '@/mixins/timesheetMixin'
import { mapActions, mapGetters } from 'vuex'
import { TimesheetOperationType } from '@/shared/constants/timesheet/TimesheetOperationType'

export default {
  name: 'TimesheetRecordsTableActions',
  mixins: [baseMixin, timesheetMixin],
  props: {
    timesheet: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      showDidNotHappenConfirmation: false,
    }
  },
  computed: {
    ...mapGetters({
      isLoadingCRUD: 'timesheets/isLoadingCRUD',
    }),
  },
  methods: {
    ...mapActions({
      submitTimesheetsForApproval: 'timesheets/submitTimesheetsForApproval',
    }),
    changeTime() {
      this.$emit('changeTime', this.timesheet)
    },
    async cancelBooking() {
      const payload = this.mapTimesheetToPayload(this.timesheet)

      payload.operationType = TimesheetOperationType.CANCEL

      const result = await this.submitTimesheetsForApproval([payload])

      if (!result?.isSuccess) return

      this.$emit('cancelBookingSubmitted', {
        result,
        timesheets: [this.timesheet],
      })

      this.showDidNotHappenConfirmation = false
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="showDidNotHappenConfirmation"
      data-testid="timesheet-records-table-actions-did-not-happen-confirmation-msg"
      class="justify-end align-center py-3"
    >
      <span class="text-caption">{{
        $t('timesheets.table.actions.didNotHappenConfirmationText')
      }}</span>
      <div>
        <v-btn
          data-testid="timesheet-records-table-actions-did-not-happen-confirm-btn"
          x-small
          depressed
          color="primary"
          class="ml-2"
          :loading="isLoadingCRUD"
          @click="cancelBooking"
          >{{ $t('general.confirm') }}</v-btn
        >

        <v-btn
          data-testid="timesheet-records-table-actions-did-not-happen-cancel-btn"
          x-small
          outlined
          class="ml-2"
          :disabled="isLoadingCRUD"
          @click="showDidNotHappenConfirmation = false"
          >{{ $t('general.cancel') }}</v-btn
        >
      </div>
    </div>
    <div v-else>
      <v-btn
        data-testid="timesheet-records-table-actions-change-times"
        x-small
        text
        color="blue"
        :title="$t('timesheets.table.actions.changeTimesTitle')"
        @click="changeTime"
      >
        <v-icon small class="mr-1">mdi-pencil</v-icon>
        {{ $t('timesheets.timesheetModifyButtonText') }}
      </v-btn>
      <v-btn
        data-testid="timesheet-records-table-actions-did-not-happen"
        x-small
        text
        color="red"
        :title="$t('timesheets.table.actions.didNotHappenTitle')"
        @click="showDidNotHappenConfirmation = true"
      >
        <v-icon small class="mr-1">mdi-cancel</v-icon>
        {{ $t('timesheets.timesheetCancelButtonText') }}
      </v-btn>
    </div>
  </div>
</template>
